import { useExperiment } from "@statsig/react-bindings";

export interface ExperimentValues {
  value: Record<string, unknown>;
  groupName: string | null;
  isControlGroup?: boolean;
}

export function useExperimentValues(
  experimentName: string,
  controlGroupName?: string,
): ExperimentValues | null {
  const { value, groupName } = useExperiment(experimentName);
  try {
    return groupName
      ? {
          value,
          groupName,
          ...(controlGroupName && {
            isControlGroup: groupName === controlGroupName,
          }),
        }
      : null;
  } catch (error) {
    console.error("Error fetching experiment values:", error);
    return null;
  }
}
